<template>
    <p>changing_collection</p>
</template>

<script>
export default {
    created () {
        this.$ls.set('userHash', this.$route.params.hash);
        this.$router.replace('/');
    }
};
</script>
